if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = this.getCart();
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.cart = this.getCart();
        const cartSections = this.getCartSectionsToRender();
        const canRenderCart =
          this.cart &&
          typeof this.cart.renderContents === 'function';

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (cartSections.length) {
          formData.append(
            'sections',
            cartSections.map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          if (this.cart && typeof this.cart.setActiveElement === 'function') this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then(async (response) => {
            const responseText = await response.text();

            if (!responseText) {
              if (response.redirected && response.url) {
                window.location = response.url;
                return null;
              }
              this.submitNativeFallback();
              return null;
            }

            try {
              return JSON.parse(responseText);
            } catch (error) {
              console.error(error);
              if (response.redirected && response.url) {
                window.location = response.url;
              } else {
                this.submitNativeFallback();
              }
              return null;
            }
          })
          .then((response) => {
            if (!response) return;

            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!canRenderCart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      try {
                        this.cart.renderContents(response);
                      } catch (error) {
                        console.error(error);
                        window.location = window.routes.cart_url;
                      }
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                try {
                  this.cart.renderContents(response);
                } catch (error) {
                  console.error(error);
                  window.location = window.routes.cart_url;
                }
              });
            }
          })
          .catch((e) => {
            console.error(e);
            this.submitNativeFallback();
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }

      getCart() {
        return document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      }

      getCartSectionsToRender() {
        if (!this.cart) return [];

        if (typeof this.cart.getSectionsToRender === 'function') {
          return this.cart.getSectionsToRender();
        }

        if (this.cart.tagName === 'CART-DRAWER') {
          return [
            { id: 'cart-drawer' },
            { id: 'cart-icon-bubble' },
          ];
        }

        if (this.cart.tagName === 'CART-NOTIFICATION') {
          return [
            { id: 'cart-notification-product' },
            { id: 'cart-notification-button' },
            { id: 'cart-icon-bubble' },
          ];
        }

        return [];
      }

      submitNativeFallback() {
        if (this.nativeFallbackTriggered) return;
        this.nativeFallbackTriggered = true;
        HTMLFormElement.prototype.submit.call(this.form);
      }
    }
  );
}
